import { Image } from '@shopify/hydrogen'
import { useI18n } from './i18n.client'
import styles from '../assets/scss/components/scroll-to-top-button.module.scss'
import { AnimatePresence, motion, useScroll } from 'framer-motion'
import { useEffect, useState } from 'react'

export const ScrollToTopButton: React.FC = () => {
  const [i18n] = useI18n()
  const { scrollY } = useScroll()
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const unsubscribeScrollYProgress = scrollY.onChange((y) => {
      setIsScrolled(y > 100)
    })

    return () => unsubscribeScrollYProgress()
  }, [])

  return (
    <AnimatePresence>
      {isScrolled && (
        <motion.div
          animate={{ opacity: 1 }}
          className={styles.scrollToTopButton}
          exit={{ opacity: 0, transition: { ease: [1, 0, 1, 1] } }}
          initial={{ opacity: 0 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          transition={{ ease: [0, 0, 0, 1] }}>
          <Image alt={i18n.translate('scroll-to-top')} height={6} src="/carousel-arrow.svg" width={21} />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
